import React from 'react';
import { Link } from 'react-router-dom';
import {
  FacebookShareButton,
  EmailShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TumblrShareButton,
} from 'react-share';

// const shareUrl = 'http://github.com';
// const title = 'GitHub';
const Share = ({ title, shareUrl}) => (
  <div className="share-post">
      <div className="share-text">
          Paylaş:
      </div>
      <div className="sharing-options">
          <FacebookShareButton
            url={shareUrl}
            quote={title}>
            <i className="fa fa-facebook"></i>
          </FacebookShareButton>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body={title}
          >
            <i className="fa fa-envelope"></i>
          </EmailShareButton>
          <TwitterShareButton
            url={shareUrl}
            title={title}
          >
            <i className="fa fa-twitter"></i>
          </TwitterShareButton>
          <LinkedinShareButton
            url={shareUrl}
            title={title}
          >
          <i className="fa fa-linkedin"></i>
          </LinkedinShareButton>
          <RedditShareButton
            url={shareUrl}
            title={title}
          >
            <i className="fa fa-reddit"></i>
          </RedditShareButton>
          <TumblrShareButton
            url={shareUrl}
            title={title}
          >
            <i className="fa fa-tumblr"></i>
          </TumblrShareButton>
      </div>
  </div>
);

export default Share;
